import React from 'react';
import GravityLogo from './GravityLogo';

const NAV = [
  { section: 'Operations', items: [
    { id: 'dashboard',     label: 'Dashboard',         icon: '▣' },
    { id: 'products',      label: 'Products',          icon: '✦' },
    { id: 'product-types', label: 'Product Types',     icon: '☆' },
    { id: 'calendar',      label: 'Calendar Settings', icon: '▦' },
    { id: 'bonus-prizes',  label: 'Bonus Prizes',      icon: '★' },
    { id: 'transactions',  label: 'Transactions',      icon: '▤' },
  ]},
  { section: 'Sales', items: [
    { id: 'coupon', label: 'Coupon', icon: '✿' },
  ]},
  { section: 'Administration', items: [
    { id: 'users',  label: 'Users',              icon: '☺', adminOnly: true },
    { id: 'stores', label: 'Stores',             icon: '⌂', adminOnly: true },
    { id: 'rights', label: 'User & Store Rights', icon: '☑', adminOnly: true },
  ]},
];

export default function Sidebar({ activePage, onNavigate, collapsed, onToggleCollapse, roleId }) {
  const isAdmin = roleId === 'ADMIN';

  const navGroups = NAV
    .map(group => ({
      ...group,
      items: group.items.filter(item => !item.adminOnly || isAdmin),
    }))
    .filter(group => group.items.length > 0);

  return (
    <div className={`sidebar${collapsed ? ' sidebar-collapsed' : ''}`}>
      <div className="sidebar-logo">
        <div className="sidebar-logo-left">
          <GravityLogo size={36} circle />
          <div className="sidebar-logo-detail">
            <div className="sidebar-logo-text">Gravity</div>
            <div className="sidebar-logo-subtitle">Instance Rewards</div>
          </div>
        </div>
        <button className="sidebar-toggle-btn" onClick={onToggleCollapse} aria-label={collapsed ? 'Open menu' : 'Close menu'}>
          {collapsed ? '›' : '‹'}
        </button>
      </div>
      <div className="sidebar-nav">
        {navGroups.map(group => (
          <div key={group.section}>
            {!collapsed && <div className="sidebar-section">{group.section}</div>}
            {collapsed && <div className="sidebar-divider" />}
            {group.items.map(item => (
              <div
                key={item.id}
                className={`sidebar-item${activePage === item.id ? ' active' : ''}`}
                onClick={() => onNavigate(item.id)}
                title={collapsed ? item.label : ''}>
                <span className="sidebar-item-icon">{item.icon}</span>
                {!collapsed && <span className="sidebar-item-label">{item.label}</span>}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
